/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  AbstractSnapshotFormComponent,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
} from '@gh/common-shared';
import { getControlValue } from '@gh/core-ui';
import { ScheduleMasterInfo } from '../../../resources/schedule-details.model';

@Component({
  standalone: false,
  selector: 'gh-construction-schedule-details-top-form',
  templateUrl: 'construction-schedule-details-top-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConstructionScheduleDetailsTopFormComponent
  extends AbstractSnapshotFormComponent<ScheduleMasterInfo> {
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() duration: number;

  get isContractStartOverridden(): boolean {
    return getControlValue(this.form.group, 'isOverridden');
  }

  constructor(private formStateBuilder: FormStateBuilder) {
    super();
  }

  protected buildForm(snapshot: FormStateSnapshot<ScheduleMasterInfo>): FormState<ScheduleMasterInfo> {
    return this.formStateBuilder.buildPlain({
      enabled: this.enabled,
      snapshot,
      children: {
        jobNumber: { enabled: false },
        customerName: { enabled: false },
        name: { enabled: false },
        siteAddress: { enabled: false },
        drawRuleCode: { enabled: false },
        isSendReportToSupervisor: void 0,
        financeApprovedDate: { enabled: false },
        councilApprovedDate: { enabled: false },
        authToCommenceDate: { enabled: false },
        contractStartDate: { enabled: false },
        isOverridden: void 0,
      },
    });
  }
}
